import { render, staticRenderFns } from "./Repartitions.vue?vue&type=template&id=c188c4d2&"
import script from "./Repartitions.vue?vue&type=script&lang=ts&"
export * from "./Repartitions.vue?vue&type=script&lang=ts&"
import style0 from "./Repartitions.vue?vue&type=style&index=0&id=c188c4d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports